import localStorageKeys from "src/core/constants/local-storage-keys";
import { UserState } from "../context/UserContext";
import {
  AUTH_ERROR,
  COMPLETE_REGISTRAION,
  CREATE_BENEFICIARY,
  GET_BENEFICIARY,
  GET_SINGLE_BENEFICIARY,
  LOGIN_USER,
  RESET_USER_PASSWORD,
  SET_AUTH_LOADING,
  SET_USER_LOADING,
  UPDATE_BENEFICIARY,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  VERIFY_OTP,
  VERIFY_OTP_ERROR,
  VERIFY_RESET_CODE,
} from "../types/user.type";

export const UserReducer = (state: UserState, action: any) => {
  switch (action.type) {
    case SET_USER_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };
    case SET_AUTH_LOADING:
      return {
        ...state,
        isAuthLoading: action.isLoading,
      };
    case UPDATE_USER:
      return { ...state, user: action.payload, isAuth: true };
    case LOGIN_USER:
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
        loading: false,
      };
    case COMPLETE_REGISTRAION:
      return {
        ...state,
        user: action.payload,
        isAuth: true,
        isCompleted: true,
      };
    case VERIFY_OTP:
      return { ...state, user: action.payload, isVerified: true };
    case RESET_USER_PASSWORD:
      return { ...state, user: action.payload, isReset: true };
    case VERIFY_RESET_CODE:
      return { ...state, user: action.payload, isReset: true };
    case CREATE_BENEFICIARY:
    case UPDATE_BENEFICIARY:
      return {
        ...state,
        beneficiary: {
          beneficiaries: [...action.payload.accounts[0].beneficiaries],
        },
      };
    case GET_BENEFICIARY:
      return {
        ...state,
        beneficiary: {
          beneficiaries: action.payload,
        },
      };
    case GET_SINGLE_BENEFICIARY:
      return {
        ...state,
        beneficiary: {
          beneficiary: action.payload,
        },
      };
    case UPDATE_USER_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
        isAuth: false,
        user: null,
      };
    case AUTH_ERROR:
      localStorage.removeItem(localStorageKeys.loginDetails);
      localStorage.removeItem(localStorageKeys.token);
      return {
        ...state,
        error: action.payload,
        loading: false,
        isAuth: false,
        user: null,
      };
    case VERIFY_OTP_ERROR:
      // localStorage.removeItem(localStorageKeys.loginDetails);
      return {
        ...state,
        error: action.payload,
        loading: false,
        isVerified: false,
        user: null,
      };

    default:
      return state;
  }
};
